<template>
    <div v-if="pages_count > 1" class="p-0">
        <div class="pagination-container d-flex flex-column flex-lg-row align-items-center fw-semibold">
            <!-- <div class="d-flex flex-row align-items-center justify-content-center">
                <label class="text-nowrap">{{lang.rowPerPage}}</label>
                <select
                    class="form-select bg-transparent text-white border-secondary ms-2"
                    style="width: 100px;"
                    @change="changePageRowCount($event)"
                >
                    <template v-for="(pc, ind) in page_row_count" :key="ind">
                        <option :value="pc" :selected="pc==pageRowCount ? true : false">{{pc}}</option>
                    </template>
                </select>
            </div> -->

            <div
                class="d-flex mb-3 mb-lg-0 me-lg-5 align-items-center justify-content-center"
            >
                <!-- <span class="text-secondary pe-4">|</span> -->
                <label class="text-nowrap">{{$filters.replace($filters.replace(lang.table_total_row, '{row_count}', row_count), '{pages_count}', pages_count)}}</label>
                <!-- <span class="text-secondary ps-4 me-sm-5">|</span> -->
            </div>

            <div
                class="d-inline-flex flex-row align-items-center justify-content-center mb-3 mb-lg-0"
                v-if="pages_count > 5"
            >
                <label class="text-nowrap">{{lang.current_page}}</label>
                <input
                    id="toPage"
                    type="number"
                    min="1"
                    :max="pages_count"
                    class="form-control bg-transparent1 text-dark ms-2"
                    style="width: 80px; border-end-end-radius: 0; border-start-end-radius: 0;"
                    :value="currentPage"
                    @keyup="changePageOnEnter"
                />
                <button class="btn btn-go-page me-sm-5" @click="changePage()" style="border-start-start-radius: 0; border-end-start-radius: 0;">
                    <i class="fas fa-angle-right"></i>
                </button>
            </div>

            <div>
                <ul v-if="pages_count > 1"
                    class="pagination m-0 d-flex align-items-center justify-content-center"
                >
                    <template v-if="pages_count>5">
                        <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                            <a class="page-link" @click="changePage(1)">
                                <i class="fas fa-angle-double-left"></i>
                            </a>
                        </li>
                        <li class="page-item" :class="currentPage == 1 ? 'disabled' : ''">
                            <a class="page-link" @click="changePage(start == 0 ? 1 : start)">
                                <i class="fas fa-angle-left"></i>
                            </a>
                        </li>
                    </template>
                    <li
                        class="page-item"
                        :class="currentPage == pg ? 'active' : ''"
                        v-for="(pg, index) in pages"
                        :key="index"
                    >
                        <a class="page-link" @click="changePage(pg)">{{pg}}</a>
                    </li>
                    <template v-if="pages_count>5">
                        <li
                            class="page-item"
                            :class="currentPage >= pages_count ? 'disabled' : ''"
                        >
                            <a class="page-link" @click="changePage( end < pages_count ? (end+1) : end )">
                                <i class="fas fa-angle-right"></i>
                            </a>
                        </li>
                        <li
                            class="page-item"
                            :class="currentPage >= pages_count ? 'disabled' : ''"
                        >
                            <a class="page-link" @click="changePage(pages_count)">
                                <i class="fas fa-angle-double-right"></i>
                            </a>
                        </li>
                    </template>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    import { onMounted, ref, watchEffect } from "vue";
    // import { useStore } from "@/system_modules/store";

    export default {
        name: 'PaginationC',
        props: ['pages_count', 'row_count', 'current_page', 'perpage', 'lang', 'page_row_count'],
        emits: ['navigate'],
        setup(props, {emit}) {
            // const store = useStore();

            // const TR = ref({});
            const currentPage = ref(1);
            const pages = ref([]);
            const pageRowCount = ref(6);

            // const page_row_count = [1, 2, 4, 6, 12, 24, 48];
            const start = ref(0);
            const end = ref(0);

            const navigate = (page, rows) => {
                createPageRange(page);
                emit('navigate', page, rows);
            };

            const changePageOnEnter = (e) => {
                if (e.which == 13) {
                    changePage();
                }
            };

            const changePage = (page) => {
                let cp;
                if (page === undefined)
                    cp = parseInt(document.getElementById("toPage").value);
                else cp = page;

                navigate(cp, pageRowCount.value);
            };

            const changePageRowCount = (event) => {
                let sel_row_count = parseInt(event.target.value);
                pageRowCount.value = sel_row_count;
                navigate(1, sel_row_count);
            };

            const createPageRange = (cp) => {
                let page_count = props.pages_count;
                let pagesl = [];

                if (page_count > 5) {
                    start.value = parseInt(Math.floor(Math.abs(cp - 1) / 5)) * 5;
                    end.value = start.value + 5;
                    if (end.value > page_count) end.value = page_count;
                } else {
                    start.value = 0;
                    end.value = page_count;
                }
                for (var i = start.value + 1; i <= end.value; i++) {
                    pagesl.push(i);
                }
                pages.value = pagesl;
            };

            watchEffect(() => {
                // TR.value = store.getTranslation();
                currentPage.value = props.current_page || 1;
                createPageRange(currentPage.value);
            });

            onMounted(() => {
                currentPage.value = parseInt(
                    props.current_page || 1
                );
                pageRowCount.value = parseInt(
                    props.perpage
                );
                createPageRange(currentPage.value);
            });

            return {
                // TR,
                changePage,
                changePageOnEnter,
                pages,
                currentPage,
                changePageRowCount,
                pageRowCount,
                // page_row_count,
                start,
                end
            };
        },
    };
</script>

<style lang="scss">
:root {
    --primary-color: var(--site-primary-color-rgb);
    --page-btn-gradient: linear-gradient( 135deg, rgba(var(--primary-color), 0.3) 0%, rgba(0, 0, 0, 0.5) 100% ) !important;

    --page-btn-gradient-hover: linear-gradient( 135deg, rgba(var(--primary-color), 0.4) 0%, rgba(0, 0, 0, 0.5) 100% ) !important;

    // --background-gradient: linear-gradient( 135deg, rgba(var(--primary-color), .2) 0%, rgba(var(--primary-color), .3) 40%, rgba(var(--primary-color), .5) 100% );
    --background-gradient: rgba(var(--primary-color), .1);

    --bs-pagination-padding-y: 0.275rem;
}
.pagination-container{
    // height: 60px;
    padding: .5rem 1.5rem;
    border-radius: 10px;
    // background: var(--background-gradient) !important;
    box-shadow: var(--shadow);
}
.pagination{
    font-family: var(--font-family);
}
.page-link {
    color: #000000;
    background-color: #ffffff40;
    border: 0;
    cursor: pointer;
}
.page-item.disabled .page-link {
    background-color: #00000020;
}
.page-item.active .page-link {
    background: var(--page-btn-gradient) !important;
    color: #ffffff;
}
.btn-go-page{
    background: var(--page-btn-gradient) !important;
    color: #ffffff;
}
.btn-go-page:hover{
    background: var(--page-btn-gradient-hover) !important;
    color: #ffffff;
}
@media(max-width: 576px){
    // .pagination-container{
    //     height: 100px;
    // }
}
</style>